"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */
var SortDirection = Object.freeze({
  ASC: "asc",
  DESC: "desc"
});
module.exports = /*#__PURE__*/function () {
  function SortOptions(field) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SortDirection.ASC;
    (0, _classCallCheck2["default"])(this, SortOptions);
    this.sortOptions = [];
    if (field) {
      this.add(field, direction);
    }
  }
  (0, _createClass2["default"])(SortOptions, [{
    key: "setDebugEnabled",
    value: function setDebugEnabled(isEnabled) {
      this.isDebugEnabled = isEnabled;
      return this;
    }
  }, {
    key: "merge",
    value: function merge(otherSortOptions) {
      var sortOptions = Object.assign(new SortOptions(), this);
      otherSortOptions.sortOptions.forEach(function (option) {
        sortOptions.add(option.field, option.direction);
      });
      return sortOptions;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.sortOptions = [];
      return this;
    }
  }, {
    key: "add",
    value: function add(field, direction) {
      var newSortObject = {
        field: field,
        direction: direction
      };
      var index = this.sortOptions.findIndex(function (sortData) {
        return sortData.field === field;
      });
      if (index >= 0) {
        this.sortOptions.splice(index, 1, newSortObject);
      } else {
        this.sortOptions.push(newSortObject);
      }
      return this;
    }
  }, {
    key: "apply",
    value: function apply(ref) {
      this.sortOptions.forEach(function (option) {
        ref = ref.orderBy(option.field, option.direction);
      });
      return ref;
    }
  }, {
    key: "hasOptionByName",
    value: function hasOptionByName(fieldName) {
      return this.sortOptions.some(function (option) {
        return option.field === fieldName;
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.sortOptions.length === 0;
    }
  }]);
  return SortOptions;
}();
module.exports.SortDirection = SortDirection;